<template>
 <section class="section">
  <div v-if="data['bio-background']" class="section-bg" :style="{ backgroundImage: 'url(' + data['bio-background']+ ')' }"></div>
  <div v-else class="section-bg" :style="{ backgroundImage: 'url(' + require(`@/assets/background.jpeg`) + ')'}"></div>
  <div class="section-inner">
   <div v-if="data['bio-avatar']" class="avatar" :style="{ backgroundImage: `url(${data['bio-avatar']})`}"></div>
   <div v-else class="avatar" :style="{ backgroundImage: 'url(' + require(`@/assets/avatar.png`) + ')'}"></div>
   <h1 v-if="data['bio-title-header']" class="title">{{ data['bio-title-header'] }}</h1>
   <h1 v-else class="title">Kết nối với Ngoại Ngữ Tomato</h1>

   <ul class="list">
    <li v-for="item in data['bio_item']" :key="item">
      <a v-if="item['type'] == 'link'" :href="item['link']" target="_blank">
        <div class="inner">
        <span><img :src="item['linkIcon']" alt="" style="border-radius: 50%;"/></span>
        <h3>{{ item['title'] }}</h3>
        </div>
      </a>
      <a v-else-if="item['type'] == 'phone'" :href="'tel:' + item['link']" target="_blank">
        <div class="inner">
        <span><img :src="item['linkIcon']" alt="" style="border-radius: 50%;"/></span>
        <h3>{{ item['title'] }}</h3>
        </div>
      </a>
      <a v-else-if="item['type'] == 'email'" :href="'mailto:' + item['link']" target="_blank">
        <div class="inner">
        <span><img :src="item['linkIcon']" alt="" style="border-radius: 50%;"/></span>
        <h3>{{ item['title'] }}</h3>
        </div>
      </a>
    </li>
    <li v-if="data['bio-title-youtube-2']">
     <a :href="data['bio-link-youtube-2']" target="_blank">
      <div class="inner">
       <span><img src="./assets/youtube.png" alt="" /></span>
       <h3>{{ data['bio-title-youtube-2'] }}</h3>
      </div>
     </a>
    </li>
    <li v-if="data['bio-link-fanpage']">
     <a :href="data['bio-link-fanpage']" target="_blank">
      <div class="inner">
       <span><img src="./assets/facebook.png" alt="" /></span>
       <h3 v-if="data['bio-title-fanpage']">{{ data['bio-title-fanpage'] }}</h3>
       <h3 v-else>Fanpage của tôi ở đây</h3>
      </div>
     </a>
    </li>
    <li v-if="data['bio-gmail']">
     <a :href="`mailto:${data['bio-gmail']}`" target="_blank">
      <div class="inner">
       <span><img src="./assets/google-plus.png" alt="" /></span>
       <h3 v-if="data['bio-title-gmail']">{{ data['bio-title-gmail'] }}</h3>
       <h3 v-else>Gmail của tôi ở đây</h3>
      </div>
     </a>
    </li>
    <li v-if="data['bio-link-zalo']">
     <a :href="data['bio-link-zalo']" target="_blank">
      <div class="inner">
       <span><img src="./assets/zalo.png" alt="" /></span>
       <h3 v-if="data['bio-title-zalo']">{{ data['bio-title-zalo'] }}</h3>
       <h3 v-else>Nhóm Zalo kết nối với tôi</h3>
      </div>
     </a>
    </li>
    <li v-if="data['bio-link-playlist']">
     <a :href="data['bio-link-playlist']" target="_blank">
      <div class="inner">
       <span><img src="./assets/video-camera.png" alt="" /></span>
       <h3 v-if="data['bio-title-playlist']">{{ data['bio-title-playlist'] }}</h3>
       <h3 v-else>Playlist video hay nhất của tôi</h3>
      </div>
     </a>
    </li>
    <li v-if="data['bio-link-podcast']">
     <a :href="data['bio-link-podcast']" target="_blank">
      <div class="inner">
       <span><img src="./assets/podcasts.png" alt="" /></span>
       <h3 v-if="data['bio-title-podcast']">{{ data['bio-title-podcast'] }}</h3>
       <h3 v-else>Podcast Phát triển Kinh doanh - Phát triển con người</h3>
      </div>
     </a>
    </li>
    <li v-if="data['bio-link-skype']">
     <a :href="data['bio-link-skype']" target="_blank">
      <div class="inner">
       <span><img src="./assets/skype.png" alt="" /></span>
       <h3 v-if="data['bio-title-skype']">{{ data['bio-title-skype'] }}</h3>
       <h3 v-else>Skype của tôi ở đây</h3>
      </div>
     </a>
    </li>
    <li v-if="data['bio-link-telegram']">
     <a :href="data['bio-link-telegram']" target="_blank">
      <div class="inner">
       <span><img src="./assets/telegram.png" alt="" /></span>
       <h3 v-if="data['bio-title-telegram']">{{ data['bio-title-telegram'] }}</h3>
       <h3 v-else>Telegram của tôi ở đây</h3>
      </div>
     </a>
    </li>
    <li v-if="data['bio-link-linkedin']">
     <a :href="data['bio-link-linkedin']" target="_blank">
      <div class="inner">
       <span><img src="./assets/linkedin.png" alt="" /></span>
       <h3 v-if="data['bio-title-linkedin']">{{ data['bio-title-linkedin'] }}</h3>
       <h3 v-else>Linkedin của tôi ở đây</h3>
      </div>
     </a>
    </li>
   </ul>

   <div class="footer">
    <p v-if="data['bio-hotline']">Hotline: <a href="#">{{ data['bio-hotline'] }}</a></p>
    <p v-if="data['bio-email']">Email: <a :href="`mailto:${data['bio-email']}`">{{ data['bio-email'] }}</a></p>
   </div>
  </div>
 </section>
</template>

<script>
import axios from 'axios'

export default {
 name: "App",
 data() {
   return {
     data: {
        "bio-title-youtube-1": null,
        "bio-link-youtube-1": null,
        "bio-title-youtube-2": null,
        "bio-link-youtube-2": null,
        "bio-title-fanpage": null,
        "bio-link-fanpage": null,
        "bio-title-gmail": null,
        "bio-gmail": null,
        "bio-title-zalo": null,
        "bio-link-zalo": null,
        "bio-title-podcast": null,
        "bio-link-podcast": null,
        "bio-title-skype": null,
        "bio-link-skype": null,
        "bio-title-telegram": null,
        "bio-link-telegram": null,
        "bio-title-linkedin": null,
        "bio-link-linkedin": null,
        "bio-hotline": null,
        "bio-avatar": null,
    }
   }
 },
 mounted () {
    const domain = 'https://tomatoonline.edu.vn';
    // const domain = 'http://localhost:8000';
    axios
      .get(domain + '/admin/api/bio-info')
      .then(response => {
        // this.data = response.data.data;
        for (const [key, value] of Object.entries(response.data.data)) {
          this.data[key] = value;
        }
        // Object.keys(this.data).map(function(key, index) {
        //   myObject[key] *= 2;
        // });
      })
  }
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
}

body {
  font-family: "Roboto", sans-serif;
  font-weight: 400;
}

img {
  max-width: 100%;
}

.section {
  position: relative;
  z-index: 5;
  min-height: 100vh;
  padding: 40px 15px;
}
@media (min-width: 400px) {
  .section {
    padding: 50px 20px;
  }
}
@media (min-width: 768px) {
  .section {
    padding: 80px 15px;
  }
}

.section-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
}
.section-bg:after {
  content: "";
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #000;
  opacity: 0.5;
}

.section-inner {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  position: relative;
  z-index: 9;
  max-width: 600px;
  margin: 0 auto;
}
.section-inner .avatar {
  border-radius: 50%;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  width: 80px;
  margin-bottom: 20px;
}
.section-inner .avatar:after {
  content: "";
  display: block;
  padding-top: 100%;
}
@media (min-width: 768px) {
  .section-inner .avatar {
    width: 120px;
  }
}
.section-inner .title {
  color: white;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  line-height: 1.2;
  margin-bottom: 30px;
}
@media (min-width: 768px) {
  .section-inner .title {
    font-size: 18px;
  }
}
.section-inner .list {
  list-style: none;
  margin: 0;
  padding: 0;
  width: 100%;
  font-size: 0;
}
.section-inner .list li {
  display: block;
}
@media (min-width: 768px) {
  .section-inner .list li:nth-child(1) a, .section-inner .list li:nth-child(2) a {
    -webkit-animation: pulse 1s ease infinite;
            animation: pulse 1s ease infinite;
  }
}
.section-inner .list li + li {
  margin-top: 15px;
}
@media (min-width: 768px) {
  .section-inner .list li + li {
    margin-top: 20px;
  }
}
.section-inner .list li a {
  display: block;
  font-size: 12px;
  letter-spacing: 0.01em;
  text-decoration: none;
  color: #000;
  background-color: #fff;
  padding: 0 10px;
  border-radius: 20px;
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
}
@media (min-width: 768px) {
  .section-inner .list li a {
    font-size: 16px;
    border-radius: 30px;
  }
  .section-inner .list li a:hover {
    -webkit-transform: scale(1.05);
            transform: scale(1.05);
  }
}
.section-inner .list li .inner {
  position: relative;
  height: 40px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  padding-left: 35px;
}
.section-inner .list li .inner span {
  position: absolute;
  top: 50%;
  left: 0;
  width: 25px;
  -webkit-transform: translateY(-50%);
          transform: translateY(-50%);
}
.section-inner .list li .inner h3 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-size: inherit;
  font-weight: inherit;
  color: inherit;
  margin: 0;
}
@media (min-width: 768px) {
  .section-inner .list li .inner {
    height: 60px;
    padding-left: 50px;
  }
  .section-inner .list li .inner span {
    width: 40px;
  }
}
.section-inner .list-2 {
  list-style: none;
  margin: 0;
  padding: 0;
  width: 100%;
  font-size: 0;
}
.section-inner .list-2 li {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}
.section-inner .list-2 li:nth-child(even) {
  -webkit-box-orient: horizontal;
  -webkit-box-direction: reverse;
      -ms-flex-direction: row-reverse;
          flex-direction: row-reverse;
}
.section-inner .list-2 li + li {
  margin-top: 20px;
}
.section-inner .list-2 .list-2__img {
  display: block;
  width: 50%;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 20px;
  overflow: hidden;
}
.section-inner .list-2 .list-2__img:after {
  content: "";
  display: block;
  padding-top: 90%;
}
.section-inner .list-2 .list-2__title {
  width: 50%;
  font-size: 12px;
  font-weight: normal;
  letter-spacing: 0.01em;
  text-decoration: none;
  color: #fff;
  text-align: center;
  padding: 0 20px;
}
.section-inner .list-2 .list-2__title a {
  color: inherit;
  text-decoration: none;
}
.section-inner .list-2 .list-2__title a:hover {
  text-decoration: underline;
}
@media (min-width: 768px) {
  .section-inner .list-2 .list-2__title {
    font-size: 16px;
  }
}
.section-inner .footer {
  color: #fff;
  text-align: center;
  margin-top: 30px;
}
.section-inner .footer a {
  color: #fff;
  text-decoration: none;
}
.section-inner .footer a:hover {
  text-decoration: underline;
}
.section-inner .footer p + p {
  margin-top: 10px;
}

@-webkit-keyframes pulse {
  from {
    -webkit-transform: scale3d(1, 1, 1);
            transform: scale3d(1, 1, 1);
  }
  50% {
    -webkit-transform: scale3d(1.05, 1.05, 1.05);
            transform: scale3d(1.05, 1.05, 1.05);
  }
  to {
    -webkit-transform: scale3d(1, 1, 1);
            transform: scale3d(1, 1, 1);
  }
}

@keyframes pulse {
  from {
    -webkit-transform: scale3d(1, 1, 1);
            transform: scale3d(1, 1, 1);
  }
  50% {
    -webkit-transform: scale3d(1.05, 1.05, 1.05);
            transform: scale3d(1.05, 1.05, 1.05);
  }
  to {
    -webkit-transform: scale3d(1, 1, 1);
            transform: scale3d(1, 1, 1);
  }
}
/*# sourceMappingURL=style.css.map */
</style>
